import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Schedule from "@/pages/Schedule";
import Week from "@/pages/Week";
import Logs from "@/pages/Logs";
import Settings from "@/pages/Settings";
import Sidebar from "@/components/Sidebar";
import { Toaster } from "@/components/ui/sonner";
import { CircleNotch } from "@phosphor-icons/react";

function Layout() {
  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white">
      <Sidebar />
      <main className="md:ml-60 p-4 sm:p-6 lg:p-8 max-w-[1600px] luminosa-main">
        <Outlet />
      </main>
    </div>
  );
}

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === undefined) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A]">
        <CircleNotch size={32} className="animate-spin text-zinc-600" />
      </div>
    );
  }
  if (user === null) return <Navigate to="/login" replace />;
  return children;
}

function LoginRoute() {
  const { user } = useAuth();
  if (user === undefined) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A]">
        <CircleNotch size={32} className="animate-spin text-zinc-600" />
      </div>
    );
  }
  if (user) return <Navigate to="/" replace />;
  return <Login />;
}

function App() {
  return (
    <AuthProvider>
      <Toaster position="top-right" richColors closeButton />
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginRoute />} />
          <Route
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route path="/" element={<Dashboard />} />
            <Route path="/semana" element={<Week />} />
            <Route path="/horarios" element={<Schedule />} />
            <Route path="/logs" element={<Logs />} />
            <Route path="/config" element={<Settings />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
